import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  text: string;
  photo: string;
}
const TestimonialCard = ({
  name,
  location,
  text,
  photo
}: TestimonialProps) => <div className="bg-brand-card p-4 rounded-2xl border border-white/10 flex flex-col h-full" data-id="element-265">
    <div className="flex text-brand-gold mb-2" data-id="element-266">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-267" />)}
    </div>
    <p className="text-gray-200 text-sm md:text-base flex-grow leading-relaxed font-normal mb-3" data-id="element-268">
      "{text}"
    </p>
    <div className="flex items-center gap-3 pt-3 border-t border-white/10" data-id="element-269">
      <img src={photo} alt={name} className="w-10 h-10 rounded-full object-cover shrink-0 border border-white/10" data-id="element-270" />
      <div data-id="element-271">
        <p className="font-semibold text-white text-xs md:text-sm leading-none mb-0.5" data-id="element-272">
          {name}
        </p>
        <p className="text-[10px] md:text-xs text-gray-400 font-normal leading-tight" data-id="element-273">
          {location}
        </p>
      </div>
    </div>
  </div>;
export function TestimonialsSection1() {
  const testimonials = [{
    name: 'Valeria M.',
    location: 'Profesora de Informática y Computación',
    text: 'Compré el Kit un domingo a la noche y el lunes ya tenía la unidad de Funciones lista con materiales y evaluación. Recuperé mi tranquilidad.',
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face'
  }, {
    name: 'Roberto C.',
    location: 'Docente de Tecnología y Sistemas',
    text: 'El Sistema Anti-IA cambió las reglas del juego. Por fin puedo evaluar el razonamiento lógico real. Es la inversión más inteligente de mi carrera.',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face'
  }, {
    name: 'Sandra P.',
    location: 'Catedrática de Programación Técnica',
    text: 'Mis colegas me preguntan qué formación hice para organizar así mis clases. Les digo que no fue un curso — fue implementar un sistema probado.',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face'
  }];
  return <section className="py-4 md:py-5 px-4 bg-brand-cardAlt border-b border-white/5" data-id="element-274">
      <div className="max-w-2xl mx-auto" data-id="element-275">
        <div className="grid grid-cols-1 gap-3" data-id="element-276">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-277" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSection2() {
  const testimonials = [{
    name: 'Valeria M.',
    location: 'Profesora de Informática y Computación',
    text: 'Compré el Kit un domingo a la noche y el lunes ya tenía la unidad de Funciones lista con materiales y evaluación. Recuperé mi tranquilidad.',
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face'
  }, {
    name: 'Roberto C.',
    location: 'Docente de Tecnología y Sistemas',
    text: 'El Sistema Anti-IA cambió las reglas del juego. Por fin puedo evaluar el razonamiento lógico real. Es la inversión más inteligente de mi carrera.',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face'
  }, {
    name: 'Sandra P.',
    location: 'Catedrática de Programación Técnica',
    text: 'Mis colegas me preguntan qué formación hice para organizar así mis clases. Les digo que no fue un curso — fue implementar un sistema probado.',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-cardAlt border-y border-white/5" data-id="element-278">
      <div className="max-w-2xl mx-auto" data-id="element-279">
        <h2 className="text-xl md:text-2xl font-extrabold text-center mb-5 text-white leading-tight" data-id="element-280">
          Lo que dicen los <span className="text-brand-accent" data-id="element-281">docentes</span>
        </h2>
        <div className="grid grid-cols-1 gap-3" data-id="element-282">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-283" />)}
        </div>
      </div>
    </section>;
}